<template>
    <div class="mb-4">
        <v-btn
            color="primary"
            data-cy="open-passport-modal"
            @click="createPassport(type, person.personId, person.language)"
        >
            {{ $t('create') }}
        </v-btn>
        <passport-modal @saved="refresh" />
    </div>
    <v-data-table
        :headers="headers"
        :items="activeDocuments"
        :items-per-page-options="useTableOptions(activeDocuments.length)"
        :items-length="activeDocuments?.length"
        disable-sort
        density="compact"
        color="primary"
        class="elevation-1 table-server"
        data-cy="documents-table"
    >
        <template v-slot:item.number="{item}">
            <div class="text-link" @click="editPassport(type, item, person.personId)">{{ item.number }}</div>
        </template>
        <template v-slot:item.type="{item}">
            {{ $t(`documentTypes.${item.type}`) }}
        </template>
        <template v-slot:item.issueDate="{item}">
            {{ item.issueDate && $filters.dateShortFormat(item.issueDate) }}
        </template>
        <template v-slot:item.validTill="{item}">
            {{ item.validTill && $filters.dateShortFormat(item.validTill) }}
        </template>
        <template v-slot:item.issuePlace="{item}">
            {{ localized(item.issuePlace) }}
        </template>
        <template v-slot:item.active="{item}">
            {{ item.active ? $t('active') : $t('inactive') }}
        </template>
    </v-data-table>
</template>

<script lang="ts">
    import {Component, mixins, Prop, Setup} from 'vue-facing-decorator'
    import {PassportMixin} from '@/components/account/mixins/PassportMixin.vue'
    import PassportModal from '~/components/modals/PassportModal.vue'
    import DocumentForm from '~/components/account/documents/DocumentForm.vue'

    @Component({
        components: {DocumentForm, PassportModal},
    })
    export class DocumentsForm extends mixins(PassportMixin) {
        @Prop({required: true}) person
        @Prop({required: true}) type
        @Prop({default: false, type: Boolean}) isMember: boolean
        @Setup(() => useLocalized()) localized: Function

        activeDocuments = []
        async mounted() {
            await this.loadData()
        }

        async loadData() {
            try {
                if (this.type === 'crmperson') {
                    const {persons} = await this.$api.privateClients.get({id: this.person.personId, locale: 'all'})
                    this.activeDocuments = persons[0].passports
                }
                if (this.type === 'person') {
                    const {users} = await this.$api.persons.get({id: this.person.personId, locale: 'all'})
                    this.activeDocuments = users[0].passports
                }
            } catch (e) {
                this.activeDocuments = []
            }
        }

        async refresh() {
            await this.loadData()
        }

        get hidePassport() {
            return false
        }

        get headers() {
            return [
                {title: this.$t('number'), value: 'number'},
                {title: this.$t('type'), value: 'type'},
                {title: this.$t('issue_date'), value: 'issueDate'},
                {title: this.$t('valid_till'), value: 'validTill'},
                {title: this.$t('issue_place'), value: 'issuePlace'},
                {title: this.$t('status'), value: 'active'},
            ]
        }
    }

    export default DocumentsForm
</script>
